import Vue from "vue";
import base from "../../baseCore";

export default Object.assign(
    {
        apiUrl: "/partner/campaign/",

        async getPartnerCampaignEstablishmentsList(id) {
            const url = this.url(`${id}/establishment-list`);

            return await Vue.http.get(url);
        }, 

        async linkPartnerCampaignToEstablishment(data, id) {
            const url = this.url(id);

            return await Vue.http.post(url, data);
        },        
    },
    base
);
